"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinalStepFormDefinition = void 0;
const FormHandlerPluginBase_1 = require("../../PluginType/FormHandler/FormHandlerPluginBase");
const FormHandlerPluginDefinition_1 = require("../../PluginType/FormHandler/FormHandlerPluginDefinition");
class FinalStepForm extends FormHandlerPluginBase_1.default {
    submit(values, action = "default") {
        return Promise.resolve({
            nextStep: values.get("next_steps")
        });
    }
}
exports.default = FinalStepForm;
exports.FinalStepFormDefinition = new FormHandlerPluginDefinition_1.default({
    id: "final_step_form",
    class: FinalStepForm
});
